export const translations = {
  nav: {
    brand: "Seaing You",
    products: "Products",
    cart: "Cart",
    profile: "Profile",
    signIn: "Sign In",
    signOut: "Sign Out",
    adminPanel: "Admin Panel",
  },
  
  footer: {
    contact: "Contact",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
    copyright: "All rights reserved.",
    kvk: "KVK",
  },
  
  landing: {
    title: "Seaing You",
    subtitle: "Fresh Seafood, Delivered Your Way",
    description: "Order premium crawfish and Chinese mitten crab for pickup at convenient locations. Choose your pickup date, select your products, and enjoy the freshest seafood available.",
    orderNow: "Order Now",
    signIn: "Sign In",
    myProfile: "My Profile",
  },
  
  products: {
    title: "Our Products",
    subtitle: "Browse our selection of fresh seafood. Click on a product to view available pickup dates and place your order.",
    viewDetails: "View Details",
    noProducts: "No products available at this time.",
    perKg: "per kg",
    inclVat: "incl btw",
    loadingError: "Failed to load products. Please try again later.",
  },
  
  productDetail: {
    backToProducts: "Back to Products",
    selectPickupLocationDate: "Select Pickup Location & Date",
    noPickupDates: "No pickup dates available for this product at this time.",
    minimumOrder: "Minimum Order",
    orderIncrement: "Order Increment",
    datesAvailable: "date",
    datesAvailablePlural: "dates",
    available: "Available",
    availablePickupDates: "Available Pickup Dates:",
    orderBy: "Order by",
    orderDetails: "Order Details",
    quantityKg: "Quantity (kg)",
    quantityPlaceholder: "Min: {min} kg",
    quantityPlaceholderWithIncrement: "Min: {min} kg, Increment: {increment} kg",
    subtotal: "Subtotal",
    addToCart: "Add to Cart",
    viewCart: "View Cart",
    addedToCart: "Added to cart!",
    selectDateError: "Please select a pickup date",
    quantityRequiredError: "Please enter a quantity",
    quantityPositiveError: "Quantity must be greater than 0",
    quantityMinError: "Minimum order quantity is {min} kg",
    quantityIncrementError: "Quantity must be in increments of {increment} kg (e.g., {min}, {example1}, {example2}...)",
    quantityExceedsError: "Only {max} kg available",
    quantityInvalidError: "Please enter a valid quantity",
    dateNoLongerAvailable: "Selected pickup date is no longer available",
    loadingError: "Failed to load product details. Please try again later.",
  },
  
  cart: {
    title: "Your Cart",
    empty: "Your cart is empty",
    browseProducts: "Browse Products",
    pickup: "Pickup",
    location: "Location",
    quantityKg: "Quantity (kg)",
    remove: "Remove",
    continueShopping: "Continue Shopping",
    orderSummary: "Order Summary",
    items: "Items",
    subtotalExclVat: "Subtotal (excl. btw)",
    vat: "BTW (9%)",
    totalInclVat: "Total (incl. btw)",
    proceedToCheckout: "Proceed to Checkout",
    quantityPositive: "Quantity must be greater than 0",
    quantityExceeds: "Only {max} kg available",
    cartEmpty: "Your cart is empty",
    fixErrors: "Please fix quantity errors before proceeding",
  },
  
  checkout: {
    title: "Checkout",
    customerInformation: "Customer Information",
    name: "Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    required: "*",
    nameRequired: "Name is required",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email format",
    phoneRequired: "Phone number is required",
    addressRequired: "Address is required",
    termsRequired: "You must accept the terms to proceed",
    cancellationPolicyRequired: "You must acknowledge the cancellation policy to proceed",
    termsText: "I understand that if I am not present at the pickup time within the time window, my order will be discarded and I will not be refunded.",
    cancellationPolicyText: "I acknowledge that orders cannot be cancelled after the last order date for the selected pickup date, as all products are fresh and procured based on confirmed order quantities.",
    continueToPayment: "Continue to Payment",
    orderSummary: "Order Summary",
    pickupDetails: "Pickup Details",
    dateTime: "Date & Time",
    location: "Location",
    items: "Items",
    cartEmpty: "Your cart is empty. Redirecting...",
    subtotalExclVat: "Subtotal (excl. btw)",
    vat: "BTW (9%)",
    totalInclVat: "Total (incl. btw)",
  },
  
  payment: {
    title: "Payment",
    completePayment: "Complete Payment",
    customerInformation: "Customer Information",
    name: "Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    pickupDetails: "Pickup Details",
    dateTime: "Date & Time",
    location: "Location",
    items: "Items",
    subtotalExclVat: "Subtotal (excl. btw)",
    vat: "BTW (9%)",
    totalAmount: "Total Amount (incl. btw)",
    reminderTitle: "Reminder:",
    reminderText: "By proceeding with payment, you confirm that you understand if you are not present at the pickup time within the time window, your order will be discarded and you will not be refunded.",
    proceedToPayment: "Proceed to Payment",
    processing: "Processing...",
    backToCheckout: "Back to Checkout",
    loading: "Loading...",
    createOrderError: "Failed to create orders",
    paymentInitError: "Failed to initialize payment",
  },
  
  paymentReturn: {
    verifying: "Verifying payment...",
    verifyingMessage: "Please wait while we confirm your payment.",
    success: "Payment Successful!",
    successMessage: "Your {count} been confirmed. Thank you for your purchase!",
    successMessageSingle: "order has",
    successMessagePlural: "orders have",
    failure: "Payment Failed",
    failureMessage: "Your payment could not be processed.",
    orderDetails: "Order {number} Details",
    orderId: "Order ID",
    orderDate: "Order Date",
    totalAmount: "Total Amount",
    status: "Status",
    pickupInformation: "Pickup Information",
    dateTime: "Date & Time",
    location: "Location",
    itemsOrdered: "Items Ordered",
    customerInformation: "Customer Information",
    name: "Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    importantTitle: "Important:",
    importantText: "Please be present at the pickup location during the scheduled time window. If you are not present, your order will be discarded and no refund will be issued.",
    placeAnotherOrder: "Place Another Order",
    returnToHome: "Return to Home",
    returnToCart: "Return to Cart",
    noSessionId: "No session ID found",
    paymentNotCompleted: "Payment was not completed. Please try again.",
    paymentFailed: "Payment failed. Please try again.",
  },
  
  profile: {
    title: "My Profile",
    loading: "Loading your profile...",
    loadError: "Failed to load profile. Please try again later.",
    accountInformation: "Account Information",
    name: "Name",
    email: "Email",
    phone: "Phone",
    memberSince: "Member Since",
    notProvided: "Not provided",
    unknown: "Unknown",
    orderHistory: "Order History",
    noOrders: "You haven't placed any orders yet.",
    placeFirstOrder: "Place Your First Order",
    orderNumber: "Order #",
    placedOn: "Placed on",
    pickupDetails: "Pickup Details",
    dateTime: "Date & Time",
    location: "Location",
    items: "Items",
    paidOn: "Paid on:",
    reminderTitle: "Reminder:",
    reminderText: "Please be present at the pickup location during the scheduled time. Late arrivals may result in order forfeiture without refund.",
    statusPaid: "Paid",
    statusPending: "Pending",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
  },
  
  contact: {
    title: "Contact Us",
    intro: "We'd love to hear from you! Feel free to reach out through any of the following methods:",
    email: "Email",
    phone: "Phone",
    wechat: "WeChat",
    wechatDescription: "Scan the QR code to add us",
    wechatQrAlt: "WeChat QR Code",
  },
  
  terms: {
    title: "Terms of Use",
    lastUpdated: "Last updated:",
    section1Title: "1. Acceptance of Terms",
    section1Content: "By accessing and using this website, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use this website.",
    section2Title: "2. Use of Service",
    section2Content: "You agree to use our service only for lawful purposes and in accordance with these Terms of Use. You are prohibited from:",
    section2Item1: "Using the service in any way that violates applicable laws or regulations",
    section2Item2: "Attempting to interfere with the proper functioning of the service",
    section2Item3: "Engaging in any fraudulent activity",
    section2Item4: "Impersonating another person or entity",
    section3Title: "3. Orders and Payment",
    section3Content: "All fresh food orders can be cancelled by contacting the support, at the latest by the last order date listed for your pickup date. After this date, the products have already been ordered and the order cannot be cancelled.",
    section4Title: "4. Product Information",
    section4Content: "We strive to provide accurate product descriptions and images. However, we do not warrant that product descriptions, images, or other content on the site are accurate, complete, reliable, current, or error-free.",
    section5Title: "5. Pickup and Delivery",
    section5Content: "Orders must be picked up at the scheduled time and location. We are not responsible for orders that are not picked up within the designated timeframe. Please contact us if you cannot make it to the pickup location in time, but we can not provide any guarantees on delivering your order.",
    section6Title: "6. Limitation of Liability",
    section6Content: "To the fullest extent permitted by law, Seaing You shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.",
    section7Title: "7. Changes to Terms",
    section7Content: "We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of the service after changes are posted constitutes acceptance of the modified terms.",
    section8Title: "8. Contact Information",
    section8Content: "For questions about these Terms of Use, please contact us at seaingyou@outlook.com",
  },
  
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated:",
    section1Title: "1. Information We Collect",
    section1Content: "We collect information that you provide directly to us, including when you create an account, place an order, or contact us for support. This may include your name, email address, phone number, delivery address, and payment information.",
    section2Title: "2. How We Use Your Information",
    section2Content: "We use the information we collect to:",
    section2Item1: "Process and fulfill your orders",
    section2Item2: "Communicate with you about your orders and our services",
    section2Item3: "Improve our products and services",
    section2Item4: "Send you marketing communications (with your consent)",
    section2Item5: "Comply with legal obligations",
    section3Title: "3. Information Sharing",
    section3Content: "We do not sell or rent your personal information to third parties. We may share your information with service providers who assist us in operating our business, such as payment processors and delivery services, under strict confidentiality agreements.",
    section4Title: "4. Data Security",
    section4Content: "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.",
    section5Title: "5. Your Rights",
    section5Content: "You have the right to access, correct, or delete your personal information. You may also object to or restrict certain processing of your data. To exercise these rights, please contact us using the information provided on our Contact page.",
    section6Title: "6. Contact Us",
    section6Content: "If you have any questions about this Privacy Policy, please contact us at seaingyou@outlook.com",
  },
  
  orderSummary: {
    title: "Order Summary",
    pickupDetails: "Pickup Details",
    dateTime: "Date & Time",
    location: "Location",
    items: "Items",
    noItems: "No items in order",
    subtotalExclVat: "Subtotal (excl. btw)",
    vat: "BTW (9%)",
    totalInclVat: "Total (incl. btw)",
  },
  
  customerInfoForm: {
    name: "Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    required: "*",
    namePlaceholder: "Enter your full name",
    emailPlaceholder: "your.email@example.com",
    phonePlaceholder: "+31 6 12345678",
    addressPlaceholder: "Street, City, Postal Code",
  },
  
  productCard: {
    price: "Price",
    perKg: "per kg",
    available: "Available",
    quantityKg: "Quantity (kg)",
    outOfStock: "Out of stock",
  },
  
  termsCheckbox: {
    acceptTerms: "I accept the",
    termsOfUse: "Terms of Use",
    and: "and",
    privacyPolicy: "Privacy Policy",
  },
  
  loading: {
    message: "Loading...",
  },
  
  error: {
    generic: "An error occurred. Please try again.",
    tryAgain: "Try Again",
  },
  
  common: {
    kg: "kg",
    perKg: "per kg",
    inclVat: "incl btw",
    exclVat: "excl. btw",
    vat: "BTW",
    total: "Total",
    subtotal: "Subtotal",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    back: "Back",
    next: "Next",
    submit: "Submit",
    close: "Close",
    yes: "Yes",
    no: "No",
    from: "from",
    to: "to",
  },
} as const;

export type TranslationKeys = typeof translations;
